var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { Notifier } from "@/common/utils/notifier";
import { CryptoHelper } from "@/app/utils/crypto-helper";
import { AuthClient, TwoFactorAuthModel, TwoFactorAuthVerificationModel, TwoFactorAuthMethodEnum } from "@/app/api/battery-portal-api";
import moment from 'moment';
import RouteNames from "@/app/router/routes";
const authClient = new AuthClient(window.apiUrl);
const userTokenKey = window.userTokenKey;
const loginNamespace = "loginModule";
let TwoFactorAuthVue = class TwoFactorAuthVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.loading = true;
        this.data = new TwoFactorAuthModel();
        this.code = "";
        this.whenTokenExpires = null;
        this.showCountdown = false;
        this.timeRemainingTokenExpire = 0;
        this.allAuthMethods = [
            { value: TwoFactorAuthMethodEnum.App, text: "App Authenticator" },
            { value: TwoFactorAuthMethodEnum.Email, text: "Email" }
        ];
        this.authMethods = [];
        this.authMethod = this.authMethods[0];
        this.sending = false;
    }
    // method
    created() {
        this.getTwoFactorAuthData();
    }
    ;
    getTwoFactorAuthData() {
        var _a;
        if (!((_a = this.loginState) === null || _a === void 0 ? void 0 : _a.userToken)) {
            this.$router.push({ name: RouteNames.Login });
            return;
        }
        authClient
            .twoFactorAuthetication(this.loginState.userToken)
            .then(response => {
            var _a;
            this.data = response;
            if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.secondsToUserTokenExpire) {
                this.whenTokenExpires = moment().add("seconds", this.data.secondsToUserTokenExpire);
            }
            if (this.data.method == TwoFactorAuthMethodEnum.None) {
                this.authMethods = this.allAuthMethods.filter(item => this.data.allowedMethods.includes(item.value));
            }
        })
            .catch((ex) => {
            console.log('error', ex);
            Notifier.onServerError(ex);
        })
            .finally(() => {
            this.countdownTimer();
            this.loading = false;
        });
    }
    ;
    verify() {
        if (!this.code)
            return;
        var model = new TwoFactorAuthVerificationModel({
            method: this.data.method,
            userToken: this.loginState.userToken,
            secret: this.data.secret,
            code: this.code
        });
        authClient
            .verifyTwoFactorAuthetication(model)
            .then((auth) => {
            localStorage.setItem(userTokenKey, CryptoHelper.encryptSync(JSON.stringify(auth)));
            window.location.href = window.baseUrl;
        })
            .catch((ex) => {
            Notifier.onServerError(ex);
        });
    }
    ;
    assignAuthMethod() {
        if (!this.authMethod)
            return;
        this.loading = true;
        var model = new TwoFactorAuthVerificationModel({
            userToken: this.loginState.userToken,
            method: this.authMethod.value,
        });
        authClient
            .saveTwoFactorAuthMethod(model)
            .then(response => {
            this.data = response;
        })
            .catch((ex) => {
            console.log('error', ex);
            Notifier.onServerError(ex);
        })
            .finally(() => {
            this.loading = false;
        });
    }
    get getCodePlaceholder() {
        switch (this.data.method) {
            case TwoFactorAuthMethodEnum.App:
                return "Enter the Code from App";
            case TwoFactorAuthMethodEnum.Email:
                return "Enter the Code from Email";
        }
        return "";
    }
    sendEmailCode() {
        if (this.sending)
            return;
        this.sending = true;
        authClient
            .twoFactorAuthSendEmailCode(this.loginState.userToken, moment().utcOffset())
            .then((result) => {
            if (!result)
                Notifier.onError("Server has failed sending the email. Please, try again!");
            else
                Notifier.onOk("Email was sent. Please enter the verification code!");
        })
            .catch((ex) => {
            Notifier.onServerError(ex);
        })
            .finally(() => {
            this.sending = false;
        });
    }
    countdownTimer() {
        if (!this.whenTokenExpires) {
            this.showCountdown = true;
            return;
        }
        var time = moment.duration(this.whenTokenExpires.diff(moment())).asSeconds();
        time = Math.round(time);
        this.timeRemainingTokenExpire = time > 0 ? time : 0;
        if (this.timeRemainingTokenExpire > 0) {
            setTimeout(() => {
                this.showCountdown = this.timeRemainingTokenExpire <= 60;
                this.countdownTimer();
            }, 1000);
        }
        else
            this.showCountdown = true;
    }
};
__decorate([
    State(loginNamespace),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], TwoFactorAuthVue.prototype, "loginState", void 0);
TwoFactorAuthVue = __decorate([
    Component({
        name: "TwoFactorAuthVue",
    })
], TwoFactorAuthVue);
export default TwoFactorAuthVue;
